// Time (ms) the selected answer stays highlighted before going to the next question.
export const ANSWER_SELECTION_TIMEOUT = 200;

// Time (ms) the previous answer stays highlighted before removing the selected answer.
export const ANSWER_RESET_TIMEOUT = 400;

export interface CurrentQuestion {
  index: number;
  direction: 'forward' | 'backward';
}

export type Answers = Record<number, number | null>;
